// import React, { useEffect, useState } from "react";
// import Select from "react-select";
// import customSelectStyles from "../ui/customSelectStyles";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faAngleRight,
//   faAngleLeft,
// } from "@fortawesome/free-solid-svg-icons";

// const Pagination = ({
//   totalRecords = 0,
//   currentPage = 1,
//   pageSize = 10,
//   onPageChange = () => {},
//   onPageSizeChange = () => {},
// }) => {
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 768);
//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const totalPages = pageSize === -1 ? 1 : Math.ceil(totalRecords / pageSize);
//   const startRecord = pageSize === -1 ? 1 : (currentPage - 1) * pageSize + 1;
//   const endRecord =
//     pageSize === -1 ? totalRecords : Math.min(currentPage * pageSize, totalRecords);

//   const pageSizeOptions = [
//     { value: 10, label: "10 / trang" },
//     { value: 20, label: "20 / trang" },
//     { value: 50, label: "50 / trang" },
//   ];

//   const selectedPageSize = pageSizeOptions.find((opt) => opt.value === pageSize);

//   // ⚙️ Nếu là giao diện mobile
//   if (isMobile) {
//     return (
//       <div className="flex flex-col items-center justify-center py-4 border-t mt-4 bg-white">
//         {/* Hiển thị thông tin */}
//         <p className="text-sm text-gray-600 mb-2">
//           Trang {currentPage}/{totalPages} • {totalRecords} kết quả
//         </p>

//         {/* Nút điều hướng */}
//         <div className="flex items-center gap-6">
//           <button
//             disabled={currentPage === 1}
//             onClick={() => onPageChange(currentPage - 1)}
//             className={`w-12 h-12 rounded-full flex items-center justify-center border text-lg font-bold transition-all ${
//               currentPage === 1
//                 ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                 : "bg-rose-200 text-white hover:bg-rose-400"
//             }`}
//           >
//             ←
//           </button>

//           <button
//             disabled={currentPage === totalPages}
//             onClick={() => onPageChange(currentPage + 1)}
//             className={`w-12 h-12 rounded-full flex items-center justify-center border text-lg font-bold transition-all ${
//               currentPage === totalPages
//                 ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                 : "bg-rose-200 text-white hover:bg-rose-400"
//             }`}
//           >
//             →
//             {/* <FontAwesomeIcon icon={faAngleLeft} /> */}
//           </button>
//         </div>
//       </div>
//     );
//   }

//   // ⚙️ Giao diện Desktop
//   const getPageNumbers = () => {
//     if (totalPages <= 6) return Array.from({ length: totalPages }, (_, i) => i + 1);
//     if (currentPage <= 3)
//       return [1, 2, 3, 4, "...", totalPages];
//     if (currentPage >= totalPages - 2)
//       return [1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
//     return [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
//   };

//   const pageNumbers = getPageNumbers();

//   return (
//     <div className="mt-4 flex items-center justify-between text-sm">
//       <span>
//         {startRecord}–{endRecord} / {totalRecords} kết quả
//       </span>
//       <div className="flex items-center gap-1">
//         {/* Nút về đầu */}
//         <button
//           className="px-2 py-1 border rounded disabled:opacity-50"
//           disabled={currentPage === 1}
//           onClick={() => onPageChange(1)}
//         >
//           ≪
//         </button>

//         {/* Nút lùi */}
//         <button
//           className="px-2 py-1 border rounded disabled:opacity-50"
//           disabled={currentPage === 1}
//           onClick={() => onPageChange(currentPage - 1)}
//         >
//           &lt;
//         </button>

//         {pageNumbers.map((page, index) =>
//           page === "..." ? (
//             <span key={`ellipsis-${index}`} className="px-2">
//               ...
//             </span>
//           ) : (
//             <button
//               key={`page-${page}-${index}`}
//               className={`px-2 py-1 border rounded ${
//                 currentPage === page ? "bg-gray-300 font-bold" : ""
//               }`}
//               onClick={() => onPageChange(page)}
//             >
//               {page}
//             </button>
//           )
//         )}

//         {/* Nút tới */}
//         <button
//           className="px-2 py-1 border rounded disabled:opacity-50"
//           disabled={currentPage === totalPages}
//           onClick={() => onPageChange(currentPage + 1)}
//         >
//           &gt;
//         </button>

//         {/* Nút cuối */}
//         <button
//           className="px-2 py-1 border rounded disabled:opacity-50"
//           disabled={currentPage === totalPages}
//           onClick={() => onPageChange(totalPages)}
//         >
//           ≫
//         </button>

//         {/* Nhãn trang */}
//         <span className="ml-3 flex-shrink-0 whitespace-nowrap">
//           Trang {currentPage} / {totalPages}
//         </span>

//         <Select
//           className="ml-2 text-center"
//           options={pageSizeOptions}
//           value={selectedPageSize}
//           onChange={(opt) => onPageSizeChange(opt?.value)}
//           styles={customSelectStyles}
//           isClearable={false}
//         />
//       </div>
//     </div>
//   );
// };

// export default Pagination;



























import React, { useEffect, useState } from "react";
import Select from "react-select";
import { 
  ChevronLeft, 
  ChevronRight, 
  ChevronsLeft, 
  ChevronsRight,
  Hash
} from "lucide-react";

const Pagination = ({
  totalRecords = 0,
  currentPage = 1,
  pageSize = 10,
  onPageChange = () => {},
  onPageSizeChange = () => {},
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Logic định dạng Select nội bộ (Inline Styles)
  const internalSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '36px',
      height: '36px',
      borderRadius: '12px',
      border: '1px solid #f3f4f6',
      backgroundColor: '#f9fafb',
      boxShadow: state.isFocused ? '0 0 0 3px rgba(220, 38, 38, 0.1)' : 'none',
      borderColor: state.isFocused ? '#dc2626' : '#f3f4f6',
      '&:hover': {
        borderColor: '#dc2626',
      },
      fontSize: '12px',
      fontWeight: '600',
      cursor: 'pointer',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 8px',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '34px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '4px',
      color: '#9ca3af',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
      border: '1px solid #f3f4f6',
      zIndex: 9999,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: '12px',
      fontWeight: '500',
      backgroundColor: state.isSelected ? '#dc2626' : state.isFocused ? '#fef2f2' : 'white',
      color: state.isSelected ? 'white' : state.isFocused ? '#dc2626' : '#4b5563',
      cursor: 'pointer',
      '&:active': {
        backgroundColor: '#dc2626',
        color: 'white',
      },
    }),
  };

  const totalPages = pageSize === -1 ? 1 : Math.ceil(totalRecords / pageSize) || 1;
  const startRecord = pageSize === -1 ? 1 : (currentPage - 1) * pageSize + 1;
  const endRecord = pageSize === -1 ? totalRecords : Math.min(currentPage * pageSize, totalRecords);

  const pageSizeOptions = [
    { value: 10, label: "10 / trang" },
    { value: 20, label: "20 / trang" },
    { value: 50, label: "50 / trang" },
  ];

  const selectedPageSize =
    pageSizeOptions.find((opt) => opt.value === pageSize) || pageSizeOptions[0];

  // Không hiển thị khi không có dữ liệu
  if (!totalRecords || totalRecords <= 0) return null;

  const getPageNumbers = () => {
    if (totalPages <= 6) return Array.from({ length: totalPages }, (_, i) => i + 1);
    if (currentPage <= 3) return [1, 2, 3, 4, "...", totalPages];
    if (currentPage >= totalPages - 2) return [1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    return [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
  };

  const pageNumbers = getPageNumbers();

  // 📱 GIAO DIỆN MOBILE
  if (isMobile) {
    return (
      <div className="flex flex-col items-center justify-center py-6 px-4 border-t bg-gray-50/30 rounded-b-2xl">
        <div className="flex items-center gap-2 mb-4 text-gray-500 font-bold text-[10px] uppercase tracking-widest">
          <Hash size={12} className="text-red-600" />
          <span>{totalRecords} kết quả • Trang {currentPage}/{totalPages}</span>
        </div>

        <div className="flex items-center gap-6">
          <button
            disabled={currentPage === 1}
            onClick={() => onPageChange(currentPage - 1)}
            className={`w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg transition-all active:scale-90 border
              ${currentPage === 1
                ? "bg-gray-50 text-gray-300 border-gray-100 cursor-not-allowed"
                : "bg-white text-red-700 border-red-50 shadow-red-100 hover:bg-red-50"
            }`}
          >
            <ChevronLeft size={24} />
          </button>

          <button
            disabled={currentPage === totalPages}
            onClick={() => onPageChange(currentPage + 1)}
            className={`w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg transition-all active:scale-90 border
              ${currentPage === totalPages
                ? "bg-gray-50 text-gray-300 border-gray-100 cursor-not-allowed"
                : "bg-white text-red-700 border-red-50 shadow-red-100 hover:bg-red-50"
            }`}
          >
            <ChevronRight size={24} />
          </button>
        </div>
      </div>
    );
  }

  // 💻 GIAO DIỆN DESKTOP
  return (
    <div className="relative z-50 mt-6 flex items-center justify-between px-6 py-4 bg-white border border-gray-100 rounded-2xl shadow-sm">
      {/* Thông tin số lượng */}
      <div className="flex items-center gap-2 text-gray-400 font-medium">
        <span className="text-gray-900 font-bold text-sm">{startRecord}–{endRecord}</span>
        <span className="opacity-30">|</span>
        <span className="text-[10px] font-bold uppercase tracking-wider italic">Tổng {totalRecords} kết quả</span>
      </div>

      <div className="flex items-center gap-2">
        {/* Nhóm điều hướng trái */}
        <div className="flex items-center gap-1 pr-3 border-r border-gray-100">
          <NavButton 
            disabled={currentPage === 1} 
            onClick={() => onPageChange(1)} 
            icon={<ChevronsLeft size={16} />} 
          />
          <NavButton 
            disabled={currentPage === 1} 
            onClick={() => onPageChange(currentPage - 1)} 
            icon={<ChevronLeft size={16} />} 
          />
        </div>

        {/* Danh sách số trang */}
        <div className="flex items-center gap-1.5 px-2">
          {pageNumbers.map((page, index) =>
            page === "..." ? (
              <span key={`ellipsis-${index}`} className="w-8 text-center text-gray-300 font-black">
                ···
              </span>
            ) : (
              <button
                key={`page-${page}-${index}`}
                className={`w-9 h-9 flex items-center justify-center rounded-xl text-xs font-black transition-all duration-300
                  ${currentPage === page 
                    ? "bg-red-400 text-white shadow-lg shadow-red-200 ring-2 ring-red-100" 
                    : "text-gray-500 hover:bg-red-50 hover:text-red-600"
                  }`}
                onClick={() => onPageChange(page)}
              >
                {page}
              </button>
            )
          )}
        </div>

        {/* Nhóm điều hướng phải */}
        <div className="flex items-center gap-1 pl-3 border-l border-gray-100">
          <NavButton 
            disabled={currentPage === totalPages} 
            onClick={() => onPageChange(currentPage + 1)} 
            icon={<ChevronRight size={16} />} 
          />
          <NavButton 
            disabled={currentPage === totalPages} 
            onClick={() => onPageChange(totalPages)} 
            icon={<ChevronsRight size={16} />} 
          />
        </div>

        {/* Dropdown chọn PageSize nội bộ */}
        <div className="ml-4 flex items-center gap-3">
          <span className="text-[10px] font-black text-gray-300 uppercase tracking-widest shrink-0">Show</span>
          <div className="w-[110px]">
            <Select
              options={pageSizeOptions}
              value={selectedPageSize}
              onChange={(opt) => onPageSizeChange(opt?.value)}
              styles={internalSelectStyles}
              isClearable={false}
              isSearchable={false}
              menuPlacement="auto"
              menuPosition="fixed"
              menuPortalTarget={
                typeof document !== "undefined" ? document.body : null
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// Component Nút điều hướng
const NavButton = ({ disabled, onClick, icon }) => (
  <button
    disabled={disabled}
    onClick={onClick}
    className={`w-9 h-9 flex items-center justify-center rounded-xl transition-all duration-200
      ${disabled 
        ? "text-gray-200 cursor-not-allowed opacity-50" 
        : "text-gray-500 hover:bg-red-50 hover:text-red-600 active:scale-90"
      }`}
  >
    {icon}
  </button>
);

export default Pagination;